import { render, staticRenderFns } from "./AddDeleteButtons.vue?vue&type=template&id=3b47a185&scoped=true"
import script from "./AddDeleteButtons.vue?vue&type=script&lang=js"
export * from "./AddDeleteButtons.vue?vue&type=script&lang=js"
import style0 from "./AddDeleteButtons.vue?vue&type=style&index=0&id=3b47a185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47a185",
  null
  
)

export default component.exports